const item = state => state.item
const items = state => state.items
const building = state => state.building

export default {
  item,
  items,
  building
}
